function toPositiveInt(v: unknown): number | null {
    if (v == null || v === '') return null;
    const n = typeof v === 'number' ? v : Number(v);
    return Number.isFinite(n) && n > 0 ? n : null;
}

function toCreditLimit(v: unknown): number | null {
    if (v == null || v === '') return null;
    const n = typeof v === 'number' ? v : Number(v);
    return Number.isFinite(n) ? n : null;
}

export function normalizeVendorAccountingRecord(row: unknown): Record<string, unknown> {
    const o =
        row && typeof row === 'object' && !Array.isArray(row)
            ? { ...(row as Record<string, unknown>) }
            : {};
    const rawId = o.id ?? o.Id ?? o.vendorId ?? o.VendorId;
    const id =
        rawId != null && rawId !== ''
            ? typeof rawId === 'number'
                ? rawId
                : Number(rawId)
            : undefined;

    const partyPayableGlAccountId = toPositiveInt(
        o.partyPayableGlAccountId ??
            o.PartyPayableGlAccountId ??
            o.partyGLID ??
            o.PartyGLID
    );
    const commissionGlAccountId = toPositiveInt(
        o.commissionGlAccountId ??
            o.CommissionGlAccountId ??
            o.commissionAccountGLID ??
            o.CommissionAccountGLID
    );
    const paymentTermId = toPositiveInt(o.paymentTermId ?? o.PaymentTermId ?? o.paymentTermID ?? o.PaymentTermID);

    return {
        ...o,
        ...(id !== undefined && Number.isFinite(id) ? { id } : {}),
        partyPayableGlAccountId,
        commissionGlAccountId,
        paymentTermId,
        creditLimit: toCreditLimit(o.creditLimit ?? o.CreditLimit),
    };
}

/** PUT /api/vendors/{id}/accounting — camelCase body like vehicleSaleGlCompanyDefaults. */
export function transformVendorAccountingWrite(data: Record<string, unknown>): Record<string, unknown> {
    return {
        partyPayableGlAccountId: toPositiveInt(
            data.partyPayableGlAccountId ?? data.partyGLID ?? data.PartyGLID
        ),
        commissionGlAccountId: toPositiveInt(
            data.commissionGlAccountId ?? data.commissionAccountGLID ?? data.CommissionAccountGLID
        ),
        paymentTermId: toPositiveInt(data.paymentTermId ?? data.paymentTermID ?? data.PaymentTermID),
        creditLimit: toCreditLimit(data.creditLimit ?? data.CreditLimit),
    };
}
